exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.status-col-success {\n  color: #09A83D;\n}\n.status-col-error {\n  color: #e84c3d;\n}\n.status-col-waiting, .status-col-processing {\n  color: #7a7a7a;\n}\n", "", {"version":3,"sources":["/usr/src/app/node_modules/@intelipost-modules/secure-recon/features/cte-upload/components/sc-cte-upload-list/ScCteUploadList.vue"],"names":[],"mappings":";AACA;EACE,eAAe;CAChB;AACD;EACE,eAAe;CAChB;AACD;EACE,eAAe;CAChB","file":"ScCteUploadList.vue","sourcesContent":["\n.status-col-success {\n  color: #09A83D;\n}\n.status-col-error {\n  color: #e84c3d;\n}\n.status-col-waiting, .status-col-processing {\n  color: #7a7a7a;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-35671a03","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/@intelipost-modules/secure-recon/features/cte-upload/components/sc-cte-upload-list/ScCteUploadList.vue
// module id = 0ouc
// module chunks = 72